import CONSTANT, { CACHE, RESPONSE_STATUS, RESPONSE_STATUS_CODE } from './constants';
import { getKey, isString } from './common';
import { isNull } from '../../../common/src/utils/common';

const _STATUS = {
  SUCCESS: [RESPONSE_STATUS.SUCCESS, RESPONSE_STATUS.S]
};

export function getErrorMessage(response) {
  const statusCode = getKey(response, 'status.code', null);
  const status = getKey(response, 'status', null);
  const cartError = getKey(response, 'cart.error', null);

  if (status && isString(status) && !_STATUS.SUCCESS.includes(status)) {
    return getKey(response, 'message', CONSTANT.GENERIC_ERROR);
  }

  if (statusCode && statusCode !== RESPONSE_STATUS_CODE.SUCCESS) {
    return getKey(response, 'status.message.message', CONSTANT.GENERIC_ERROR);
  }

  if (cartError) {
    return cartError;
  }

  return null;
}

export function ifSuccessOrThrowError(response, successCallback) {
  const error = getErrorMessage(response);
  if (isNull(error)) {
    return successCallback(response);
  }

  throw new Error(error);
}

export function getDeferredCallbackResponseForEvent(cache, deferredEvent, ...payload) {
  const config = cache.getData(CACHE.MERCHANT_CONFIG);

  return new Promise((resolve, reject) => {
    config.handler
      .deferred(deferredEvent, ...payload)
      .then(response => {
        ifSuccessOrThrowError(response, callbackResponse => {
          resolve(callbackResponse);
        });
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function initiateCheckout(payload) {
  return getDeferredCallbackResponseForEvent(CONSTANT.DEFERRED_EVENTS.INITIATE_TXN, payload);
}



// WEBPACK FOOTER //
// ./utils/deferred-utils.js